<template>
  <div>
    <div class='row between pb-10'>
      <div>
        <button class='blue pad' @click="toggleViewJson">
          {{ viewJson ? 'Close JSON view' : 'View JSON' }}
        </button>
      </div>
      <div>
        <button
          @click="() => moveHead(-1)"
          class='red pad'
          :disabled="obStateHead === 0 || obState.length < 1"
        >
          Undo
        </button>
        <button
          @click="() => moveHead(1)"
          class='green pad ml-10'
          :disabled="!(obStateHead <= obState.length)"
        >
          Redo
        </button>
      </div>
    </div>
    <div v-if="viewJson" class='mt-15 mb-15 card'>
      <p class='card-title'><strong>Json Viewer</strong></p>
      <pre class='p-10'>{{ JSON.stringify(renderObject, null, 4) }}</pre>
    </div>
    <render-object-structure
      :rootObject="renderObject"
      :activeNode="activeNode"
      nodeId="root"
      :handleNodeClick="handleNodeClick"
      :menuItemClick="menuItemClick"
      :handleAddChild="handleAddChild"
      :collapsed="collapsed"
      :toggleCollapsed="toggleCollapsed"
      :handleDropSectionClick='handleDropSectionClick'
      :dropMode="dropMode"
      :handleFieldChange="handleFieldChange"
      :editingKey="editingKey"
    />
    <div class='container pt-20 d-flex right'>
      <button
        class='btn red pad'
        @click="handleDelete"
        v-if="selectedId"
      >
        Delete
      </button>
      <button
        class='btn green pad ml-15'
        @click="handleSave"
      >
        Save
      </button>
    </div>
  </div>
</template>

<script>
import RenderObjectStructure from "./RenderObjectStructure.vue";
import { nodeTypes, tempData } from './constants'
export default {
  name: "RenderObjectContainer",
  props: ["rootObject", "handleSaveClick", "handleDelete", "selectedId"],
  components: { RenderObjectStructure },
  data: () => ({
    collapsed: [],
    renderObject: {},
    activeNode: null,
    selectedObject: null,
    nodeCopy: null,
    dropMode: null,
    editingKey: null,
    obState: [],
    obStateHead: 1,
    viewJson: false
  }),
  mounted: function () {
    if (this.rootObject === 'NEW') {
      this.renderObject = JSON.parse(JSON.stringify(tempData))
    } else {
      const obstring = JSON.stringify(this.rootObject)
      this.renderObject = JSON.parse(obstring)
    }
  },
  methods: {
    toggleViewJson () { this.viewJson = !this.viewJson },
    moveHead (dir) {
      let newHead
      if (dir < 0 && this.obStateHead > this.obState.length) {
        this.obState.push(JSON.stringify(this.renderObject))
        newHead = this.obStateHead - 2
      } else {
        newHead = this.obStateHead + dir
        if (newHead > this.obState.length - 1) {
          newHead = this.obState.length - 1
        }
      }
      this.obStateHead = newHead
      this.renderObject = JSON.parse(this.obState[this.obStateHead])
    },
    increaseObjState() {
      if (this.obStateHead > this.obState.length) {
        let newState = [...this.obState]
        newState.push(JSON.stringify(this.renderObject))
        if (newState.length > 5) {
          newState.shift()
        }
        this.obState = newState
        this.obStateHead = this.obState.length + 1
      } else {
        let newState = []
        for (let i=0; i<this.obStateHead + 1; i++) {
          newState.push(this.obState[i])
        }
        this.obState = newState
        this.obStateHead = this.obState.length + 1
      }
    },
    handleFieldChange (key, value, node) {
      const { parentType, parent, targetKey } = this.getParentNode(node)
      if (parentType === 'object') {
        if (key !== 'key') {
          parent[targetKey] = value
        } else {
          this.editingKey = value
        }
      } else if (parentType === 'array') {
        parent[targetKey] = value
      }
    },
    handleDropSectionClick(node) {
      this.increaseObjState()
      if (this.dropMode === 'copy') {
        const { parentType, parent, targetKey } = this.getParentNode(node)
        if (parentType === 'array') {
          parent.splice(targetKey, 0, this.nodeCopy)
        }
        if (targetKey === 'object') {
          Object.keys(this.nodeCopy).forEach(k => {
            let useKey = k
            if (parent[useKey]) {
              let iter = 1
              while (parent[`${useKey}_${iter}`]) {
                iter++
              }
              useKey = `${useKey}_${iter}`
            }
            parent[useKey] = this.nodeCopy[k]
          })
        }
      }
      this.dropMode = null
      this.nodeCopy = null
      this.collapsed = []
    },
    handleSave() {
      this.handleSaveClick && this.handleSaveClick(this.renderObject)
    },
    toggleCollapsed(id){
      if (this.collapsed.includes(id)) {
        this.collapsed = [...this.collapsed].filter(i => i !== id)
      } else this.collapsed.push(id)
    },
    getParentNode (node) {
      if (node === 'root') {
        return {
          parentType: Array.isArray(this.renderObject)
            ? 'array' : 'object',
          parent: this.renderObject,
          targetKey: 'object'

        }
      }
      let iter = 0
      let keepGoing = true
      let targetKey = null
      const path = node.split(' > ')
      let head = this.renderObject
      let parentType = null
      if (path.length === 2) {
        parentType = Array.isArray(head) ? 'array' : 'object'
        iter = 0
      } else if (iter === 0 && path[0] === 'root') {
        iter = 1
      }
      while (keepGoing) {
        if (!parentType) head = head[path[iter]]
        if (iter === path.length - 2) {
          parentType = Array.isArray(head) ? 'array' : typeof head
        }
        if (parentType) {
          targetKey = path[iter + 1]
          keepGoing = false
        }
        iter++
      }
      return { parentType, parent: head, targetKey }
    },
    getTargetNode (node) {
      let iter = 0
      let keepGoing = true
      const path = node.split(' > ')
      let head = this.renderObject
      let type = null
      if (path.length === 1) {
        return { 
          type: Array.isArray(head)
            ? 'array' : 'object', 
          targetNode: head 
        }
      } else if (iter === 0 && path[0] === 'root') {
        iter = 1
      }
      while (keepGoing) {
        if (!type) head = head[path[iter]]
        if (iter === path.length - 1) {
          type = Array.isArray(head) ? 'array' : typeof head
        }
        if (type) keepGoing = false
        iter++
      }
      return { type, targetNode: head }
    },
    menuItemClick(action, node, nodeCopy) {
      if (action === 'delete') {
        this.increaseObjState()
        const { parentType, parent, targetKey } = this.getParentNode(node)
        if (parentType === 'object') {
          delete parent[targetKey]
          try {
            const split = node.split(' > ')
            split.pop()
            const {parentType: testType, parent: testParent, targetKey: testKey }
              = this.getParentNode(split.join(' > '))
            if (testType === 'array') {
              testParent.splice(parseInt(testKey), 1)
            }
          } catch { '' }
        }
        if (parentType === 'array') parent.splice(parseInt(targetKey), 1)
      }
      if (['copy', 'move'].includes(action)) {
        this.nodeCopy = JSON.parse(JSON.stringify(nodeCopy))
        this.dropMode = action
      }
      this.activeNode = null;
    },
    handleAddChild(addType, node, child = null) {
      this.increaseObjState()
      if (addType === 'convert-object') {
        const { parent, targetKey } = this.getParentNode(node)
        let useVal = parent[targetKey]
        if (!useVal || useVal === '' || (typeof useVal === 'object' && Object.keys(useVal) < 1)) {
          useVal = 'new val'
        }
        const newValue = {
          'originalVal': useVal,
          'newKey': 'new Val'
        }
        parent[targetKey] = newValue
      } else if (addType === 'convert-array') {
        const { parent, targetKey } = this.getParentNode(node)
        const newValue = [
          parent[targetKey],
          'new Val'
        ]
        parent[targetKey] = newValue
      } else {
        const { type, targetNode } = this.getTargetNode(node)
        const addNode = child || nodeTypes()[type][addType]
        type === 'array' && targetNode.push(addNode)
        type === 'object' && (Object.keys(addNode)
          .forEach(k => targetNode[k] = addNode[k]))
      }
      this.activeNode = null;
    },
    handleNodeClick(node) {
      if (this.activeNode && this.activeNode !== '' && this.editingKey) {
        this.increaseObjState()
        const { parent, targetKey } = this.getParentNode(this.activeNode)
        let useKey = this.editingKey === '' ? '1' : this.editingKey 
        if (parent[useKey]) {
          let iter = 1
          while (parent[`${useKey}_${iter}`]) {
            iter++
          }
          useKey = `${useKey}_${iter}`
        }
        parent[useKey] = parent[targetKey]
        delete parent[targetKey]
        this.editingKey = null
      }
      if (node === this.activeNode) this.activeNode = null
      else this.activeNode = node;
      if (this.dropMode) {
        this.dropMode = null
        this.nodeCopy = null
      }
      this.editingKey = null
    },
  },
};
</script>

<style scoped>
pre {
  color: gray;
  line-height: 1.7rem;
  white-space: pre-wrap;
}
</style>